<ng-template #deviceFinderModal let-modal style="min-height: 400px">

  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{'DEVICE_FINDER' | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form (ngSubmit)="onSubmit(f)" #f="ngForm">
    <input name="deviceUID" required class="form-control deviceUID"
           [placeholder]="'ENTER_UID' | translate" ngModel>
    <button class="btn btn-info searchButton" type="submit">{{'SEARCH' | translate }}</button>
  </form>
  <app-progressbar *ngIf="showSpinner"></app-progressbar>
  <table class="table" *ngIf="showTable">
    <tbody>
    <tr>
      <th>UID</th>
      <td>{{deviceSearched.uid}}</td>
    </tr>
    <tr>
      <th>{{'ID' | translate}}</th>
      <td>{{deviceSearched.id}}</td>
    </tr>
    <tr>
      <th>{{'LEVEL' | translate}}</th>
      <td>{{deviceLevelName}}</td>
    </tr>
    <tr>
      <th>{{'PROJECT' | translate}}</th>
      <td>{{deviceProjectName}}</td>
    </tr>
    <tr>
      <th>{{'LOCATION' | translate}}</th>
      <td>{{deviceLocationName}}</td>
    </tr>
    <tr>
      <th>{{'DEVICE_TYPE' | translate}}</th>
      <td>
        <mat-chip>{{deviceSearched.device_type.type}}<span class="inner-badge"
                                                           *ngIf="deviceSearched.unit">{{deviceSearched.unit.value|translate}}</span>
          <span class="inner-badge-length" *ngIf="deviceSearched.length">{{deviceSearched.length}}m</span></mat-chip>
      </td>
    </tr>
    <tr>
      <th>{{"CHILDREN_DEVICE" | translate}}</th>
      <td><span *ngFor="let child of deviceSearched.children" [ngbTooltip]="child.uid"><mat-chip
        matBadgePosition="below after" matBadgeColor="accent"
        [matBadge]="child.channel"
        [removable]="true">{{child.device_type.type}} </mat-chip></span>
        <span *ngIf="deviceSearched.children.length < 1">-</span></td>
    </tr>
    <tr>
      <th>{{'ACTIONS' | translate}}</th>
      <td>
        <div class="d-flex">
          <app-device-crud [deviceId]="deviceSearched.id" [mode]="'read'" [deviceType]="deviceTypes"
                           [unitList]="unitList" (deviceLoading)="showSpinner = $event"></app-device-crud>

          <app-device-crud [deviceId]="deviceSearched.id" [mode]="'update'" [deviceType]="deviceTypes"
                           [unitList]="unitList" (deviceLoading)="showSpinner = $event"
                           [displayLink]="null"></app-device-crud>

          <app-device-crud [deviceId]="deviceSearched.id" [mode]="'delete'" [deviceType]="deviceTypes"
                           [unitList]="unitList" (deviceLoading)="showSpinner = $event"></app-device-crud>
        </div>
      </td>
    </tr>
    </tbody>
  </table>


</ng-template>


<button type="button" class="btn top-list-tools" (click)="open(deviceFinderModal)"
        placement="left">
  <fa-icon [icon]="faSearch"></fa-icon>
  {{'DEVICE_FINDER'|translate}}
</button>
